module.exports = require("@web3auth/base");